import './ContactInfo.scss';

import PropTypes from 'prop-types';
import React from 'react';

import { classNames } from '../../utils';
import CompanyAddress from '../CompanyAddress';
import Logo from '../../icons/logo.svg';
import SocialMedia from '../SocialMedia';
import TeleList from '../TeleList';

function ContactInfo({appearance="simple", className}) {
  return (
    <section className={classNames('contact-info', className)}>
      <div>
        {appearance === 'full' && <Logo className="contact-info__logo" />}
        <CompanyAddress
          includeName={appearance === 'simple'}
          className="contact-info__address"
        />
        <TeleList
          appearance={appearance === 'full' ? 'inline' : null}
          className="contact-info__numbers"
        />
        <SocialMedia
          alignment={appearance==='full' ? 'center' : null}
          size={appearance==='full' ? 'small' : null}
        />
      </div>
    </section>
  );
}

ContactInfo.propTypes = {
  appearance: PropTypes.oneOf(['simple', 'full'])
}

export default ContactInfo;
